import { getQuoteProperty } from '../utils/quote';
import { setHref } from '../utils/location';
import { isCPQQuote } from '../utils/templates';
import { getCPQQuoteEditorRoute } from '../constants/cpqQuote';
export const directToCPQQuoteEditor = quote => {
  const contentId = getQuoteProperty(quote, 'hs_content_id');
  if (!isCPQQuote(quote) || !contentId) return;
  const route = getCPQQuoteEditorRoute(contentId);
  setHref(route);
};